import { form } from '../formState'
import { AdditionalDrivingTime } from './fields/AdditionalDrivingTime'
import { DrawRoadSegment } from './fields/DrawRoadSegment'
import { Name } from './fields/Name'
import { Type } from './fields/Type'

export function FormContent() {
  return (
    <>
      <Name />

      <form.Fieldset spacing={0}>
        <Type />
        <AdditionalDrivingTime />
      </form.Fieldset>

      <DrawRoadSegment />
    </>
  )
}
